import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filters", "filterBtn"]
  
  connect() {
    this.isOpen = false
  }
  
  toggleFilters() {
    this.isOpen = !this.isOpen
    
    if (this.hasFiltersTarget) {
      if (this.isOpen) {
        this.filtersTarget.style.display = 'block'
        this.filtersTarget.style.maxHeight = '0px'
        // Trigger reflow
        this.filtersTarget.offsetHeight
        this.filtersTarget.style.maxHeight = this.filtersTarget.scrollHeight + 'px'
      } else {
        this.filtersTarget.style.maxHeight = '0px'
        setTimeout(() => {
          this.filtersTarget.style.display = 'none'
        }, 300)
      }
    }
    
    if (this.hasFilterBtnTarget) {
      this.filterBtnTarget.classList.toggle('is-active', this.isOpen)
    }
  }
  
  closeFilters() {
    if (this.isOpen) {
      this.toggleFilters()
    }
  }
}
